import { FETCH_ALL_METRICS, FETCH_METRIC } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

// Reach/Impact are each just a handful of curated items - fetch a generous
// limit in one request and skip pagination UI entirely, rather than relying
// on the backend's smaller default page size.
const METRICS_FETCH_LIMIT = 100;

export const fetchMetricsData = (category, page) => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_METRICS,
    message: `All metrics data`,
    payload: fetchService(
      `${baseUrl.backend}/api/metrics?category=${encodeURIComponent(
        category
      )}&page=${page}&limit=${METRICS_FETCH_LIMIT}`
    ),
  });

export const fetchMetricData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_METRIC,
    message: `Metric data`,
    payload: fetchService(`${baseUrl.backend}/api/metrics/${id}`),
  });
